<template>

  <v-navigation-drawer app
                       v-model="visible"
                       :mini-variant.sync="isMiniVariant"
                       :width="385"
                       :absolute="false"
                       :permanent="false"
                       :clipped="true"
                       :dark="true"
                       color="primary">

    <template v-slot:prepend>

      <v-list color="secondary">

        <v-list-item color="primary" link>

          <v-list-item-avatar>

            <v-btn icon title="Open Wizard Preferences">
              <v-icon class="white--text">mdi-image-filter-none</v-icon>
            </v-btn>

          </v-list-item-avatar>

          <v-list-item-title class="accent--text text-center mt-2">
            Wizard Preferences

            <div class="text-center my-2">
              <v-btn-toggle v-model="tab"
                            active-class="primary accent--text"
                            color="red lighten-2">
                <v-btn small color="secondary">
                  Residential
                </v-btn>
                <v-btn small color="secondary">
                  Business
                </v-btn>
              </v-btn-toggle>
            </div>


            <!--            <v-tabs v-model="tab"-->
            <!--                    mandatory-->
            <!--                    centered-->
            <!--                    background-color="transparent"-->
            <!--                    @change="updateUseCategory"-->
            <!--            >-->
            <!--              <v-tab>Residential</v-tab>-->
            <!--              <v-tab>Business</v-tab>-->
            <!--            </v-tabs>-->

          </v-list-item-title>

          <v-btn
            icon
            @click.stop="isMiniVariant = !isMiniVariant"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

        </v-list-item>

      </v-list>

    </template>

    <template v-slot:append>

      <v-list color="secondary">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-restart</v-icon>
          </v-list-item-avatar>
          <v-list-item-title class="white--text">
            <v-btn color="primary" height="50" @click="clear" block>
              Reset Preferences
            </v-btn>
          </v-list-item-title>
        </v-list-item>

      </v-list>

    </template>

    <div v-if="tab === 0">
      <!-- Begin Residential tab content -->

      <v-list nav dense dark tile class="preference-list" color="primary">

        <v-list-item color="transparent">
          <v-list-item-icon class="text-center">
            <v-icon v-if="preferences.scale.value">mdi-checkbox-marked-outline</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0 transparent">
            <v-select
              @change="updatePreferences"
              label="Scale"
              v-model="preferences.scale"
              :items="models.scale"
              return-object
              shaped filled
              persistent-hint
              :hint="preferences.scale.description"
            ></v-select>
            <v-divider class="my-2"></v-divider>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon class="text-center">
            <v-icon v-if="preferences.usePattern.value">mdi-checkbox-marked-outline</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-select
              @change="updatePreferences"
              label="Use Pattern"
              v-model="preferences.usePattern"
              :items="models.usePattern"
              return-object
              shaped filled
              persistent-hint
              :hint="preferences.usePattern.description"
            ></v-select>
            <v-divider class="my-2"></v-divider>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <!-- End Residential tab content -->
    </div>

    <div v-if="tab === 1">
      <!-- Begin Business tab content -->

      <v-list nav dense dark tile class="preference-list" color="primary">

        <v-list-item>
          <v-list-item-icon class="text-center">
            <v-icon v-if="preferences.businessType.value">mdi-checkbox-marked-outline</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-select
              @change="updatePreferences"
              label="Use Pattern"
              v-model="preferences.businessType"
              :items="models.businessType"
              return-object
              shaped filled
              persistent-hint
              :hint="preferences.businessType.description"
            ></v-select>
            <v-divider class="my-2"></v-divider>
          </v-list-item-content>
        </v-list-item>


        <v-list-item>
          <v-list-item-icon class="text-center">
            <v-icon v-if="preferences.businessSpeed.value">mdi-checkbox-marked-outline</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-select
              @change="updatePreferences"
              label="Use Pattern"
              v-model="preferences.businessSpeed"
              :items="models.businessSpeed"
              return-object
              shaped filled
              persistent-hint
              :hint="getBusinessSpeedSelectText(preferences.businessSpeed)"
            ></v-select>
            <v-divider class="my-2"></v-divider>
          </v-list-item-content>
        </v-list-item>


        <v-list-item>
          <v-list-item-icon class="text-center">
            <v-icon v-if="preferences.capacity.value">mdi-checkbox-marked-outline</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-text-field
              @input="updatePreferences"
              label="Capacity"
              type="number"
              step="5"
              v-model="preferences.capacity.number"
              shaped filled
              persistent-hint
              hint="How many users you serve."
            ></v-text-field>
            <v-divider class="my-2"></v-divider>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <!-- End Business tab content -->
    </div>

    <!--      <pre>{{preferences}}</pre>-->

    <!--      <v-list-item>-->
    <!--        <v-list-item-icon class="text-center">-->
    <!--          <v-icon v-if="preferences.useCategory.value">mdi-checkbox-marked-outline</v-icon>-->
    <!--          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>-->
    <!--        </v-list-item-icon>-->
    <!--        <v-list-item-content class="py-0">-->
    <!--          <v-select-->
    <!--            class=""-->
    <!--            @change="updatePreferences"-->
    <!--            label="Use Category"-->
    <!--            v-model="preferences.useCategory"-->
    <!--            :items="models.useCategories"-->
    <!--            return-object-->
    <!--            shaped filled-->
    <!--            persistent-hint-->
    <!--            :hint="'The category will affect the rest of your choices.'"-->
    <!--          ></v-select>-->
    <!--          <v-divider class="my-2"></v-divider>-->
    <!--        </v-list-item-content>-->
    <!--      </v-list-item>-->

    <v-list-item>
      <v-list-item-icon class="text-center">
        <v-icon v-if="preferences.county.value">mdi-checkbox-marked-outline</v-icon>
        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="py-0">
        <v-select
          @change="updatePreferences"
          v-model="preferences.county"
          :items="models.county"
          label="County"
          :multiple="false"
          hint="Select County To Narrow Results"
          persistent-hint
          return-object
          shaped filled
        ></v-select>
        <v-divider class="my-2"></v-divider>
      </v-list-item-content>
    </v-list-item>


    <v-list-item>
      <v-list-item-icon class="text-center">
        <v-icon v-if="preferences.locations.length">mdi-checkbox-marked-outline</v-icon>
        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="py-0">
        <v-select
          @change="updatePreferences"
          v-model="preferences.locations"
          :items="allLocations"
          label="Community"
          :multiple="true"
          hint="Select one or more locations"
          persistent-hint
          return-object
          shaped filled
          :chips="true"
          :deletable-chips="true"
        ></v-select>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-icon class="text-center">
        <v-icon v-if="preferences.coordinates">mdi-checkbox-marked-outline</v-icon>
        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="py-0">
        <v-btn outlined small v-if="!preferences.coordinates"
               :to="`/wizard/${preferences.useCategory.value}?step=4`">
          Set Coordinates
        </v-btn>
        <v-text-field
          v-else
          label="Coordinates"
          type="text"
          :value="$store.getters.coordinatesFormatted"
          shaped filled
          clearable
          persistent-hint
          hint="This can only be set by clicking on the map in the Wizard."
          @click:clear="clearCoordinates"
        ></v-text-field>
      </v-list-item-content>
    </v-list-item>

  </v-navigation-drawer>

</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {

  name: 'Wizard.Preferences',

  data() {
    return {
      tab: 0,
      models: this.$store.getters.models,
      preferences: null,
      isMiniVariant: true,
      visible: false,
    };
  },

  created() {
    this.preferences = cloneDeep(this.$store.state.wizard.preferences);
    this.setTab();
  },

  mounted() {
    this.setDrawer();
  },

  watch: {

    '$store.state.wizard.preferences': {
      deep: true,
      handler(preferences, oldPreferences) {
        if (preferences !== oldPreferences) {
          this.preferences = cloneDeep(this.$store.state.wizard.preferences);
        }
        this.setTab();
      },
    },

    $route() {
      this.setDrawer();
    },

    tab(tab) {
      this.updateUseCategory(tab);
    },

  },

  computed: {

    drawerExpanded() {
      const isWizardName = this.$route.name.toLowerCase().includes('wizard');
      return !isWizardName;
    },

    category() {
      return this.preferences.useCategory.value;
    },

    speedPreference() {
      return this.$store.getters.speedPreference;
    },

    allLocations() {
      return this.$store.getters.locationsFiltered;
    },

  },

  methods: {

    setTab() {
      if (this.preferences.useCategory) {
        this.tab = this.models.useCategories.findIndex(i => i.value === this.preferences.useCategory.value);
      } else {
        this.tab = 0;
      }
    },

    updateUseCategory(index) {
      this.preferences.useCategory = this.models.useCategories[index];
      this.updatePreferences();
    },

    setDrawer() {
      if (this.$route.name === 'wizard-offerings' && this.isMiniVariant === true) {
        this.isMiniVariant = false;
      }

      if (this.$route.name === 'wizard-start' && this.isMiniVariant === false) {
        this.isMiniVariant = true;
      }

      // this.isMiniVariant = isWizardRoute && !isWizardOffering;

      const blacklist = [
        'search-for-service',
        'partners',
        'partners-detail',
      ];

      this.visible = !blacklist.includes(this.$route.name);
    },

    updatePreferences() {
      if (this.preferences.county.text !== this.$store.state.wizard.preferences.county.text) {
        this.preferences.locations = [];
      }
      this.$store.dispatch('setPreferences', this.preferences);
    },

    clear() {
      this.$store.dispatch('resetPreferences');
    },

    clearCoordinates() {
      this.preferences.coordinates = null;
      this.updatePreferences();
    },

    getBusinessSpeedSelectText(item) {
      if (this.preferences.businessType.value && item && item.number) {
        const speed = item.number[this.preferences.businessType.value];
        return item.description.replace('{}', `${speed} Mbps`);
      }
      return 'Select speed based on use pattern.';
    },

  },

};
</script>

<style>

  .v-navigation-drawer__content::-webkit-scrollbar {
    width: 18px;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: -webkit-gradient(linear, left top, left bottom, from(#CCC), to(#b4b4b4));
    box-shadow: inset 1px 1px 1px rgba(255, 255, 255, .25), inset -1px -1px 1px rgba(0, 0, 0, .25);
  }

  .v-navigation-drawer__content::-webkit-scrollbar-track {
    background-color: #fff;
    background: linear-gradient(to right, #005695, #005695 1px, #005695 1px, #005695);
  }

</style>
